export interface Comic {
  id: string;
  title: string;
  author: string;
  rating: number;
  category: string;
  tags: string[];
  coverImage: string;
  description: string;
  chapters: number;
  updateDate: string;
  rank: number;
  isHot: boolean;
  isNew: boolean;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱韩漫，感受心动瞬间' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '奇幻冒险的异世界韩漫之旅' },
  { slug: 'dongzuo', name: '动作', icon: 'ri-sword-line', description: '热血沸腾的动作韩漫精选' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理韩漫' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松愉快的搞笑韩漫合辑' },
  { slug: 'juqing', name: '剧情', icon: 'ri-book-open-line', description: '深度剧情的精品韩漫推荐' },
];

export const comics: Comic[] = [
  {
    id: 'wo-duli-shengji',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    rating: 9.6,
    category: 'dongzuo',
    tags: ['奇幻', '动作', '热血'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20powerful%20male%20warrior%20with%20dark%20hair%20and%20glowing%20eyes%2C%20dramatic%20action%20pose%2C%20dark%20fantasy%20atmosphere%2C%20minimal%20background%20with%20subtle%20gradient%2C%20clean%20composition%2C%20vibrant%20colors%2C%20manga%20cover%20art%20quality&width=400&height=560&seq=comic-solo-leveling&orientation=portrait',
    description: '十年前，世界上突然出现了连接异次元的"门"，同时部分人类觉醒了特殊能力，被称为"猎人"。主人公成振宇是被称为"人类最弱兵器"的E级猎人，在一次地下城探险中濒死之际，获得了神秘的"系统"能力，从此开始了不断升级变强的道路。',
    chapters: 179,
    updateDate: '2024-08-01',
    rank: 1,
    isHot: true,
    isNew: false,
  },
  {
    id: 'quanzhi-duzhe-shijiao',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    rating: 9.5,
    category: 'qihuan',
    tags: ['奇幻', '冒险', '生存'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20young%20man%20with%20glasses%20holding%20a%20book%2C%20fantasy%20elements%20surrounding%20him%2C%20dramatic%20lighting%2C%20clean%20minimal%20background%2C%20vibrant%20digital%20art%2C%20manga%20cover%20style&width=400&height=560&seq=comic-omniscient-reader&orientation=portrait',
    description: '金独子是一个普通上班族，唯一的爱好是阅读网络小说《在灭亡的世界中存活的三种方法》。当小说连载十年完结的那天，小说中的世界竟然变成了现实，而金独子是唯一知道这个世界结局的人。',
    chapters: 210,
    updateDate: '2024-07-28',
    rank: 2,
    isHot: true,
    isNew: false,
  },
  {
    id: 'nvshen-jianglin',
    title: '女神降临',
    author: '喵喵',
    rating: 9.3,
    category: 'lianai',
    tags: ['恋爱', '校园', '美妆'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20hair%20and%20perfect%20makeup%2C%20soft%20romantic%20atmosphere%2C%20pastel%20tones%2C%20clean%20background%2C%20elegant%20manga%20cover%20art&width=400&height=560&seq=comic-true-beauty&orientation=portrait',
    description: '从小因为外貌被欺负的林周京，通过化妆技巧变成了校园女神。她隐藏真实面貌，在校园里过着双重生活，却意外卷入了与两位校草之间的感情纠葛。',
    chapters: 223,
    updateDate: '2024-07-25',
    rank: 3,
    isHot: true,
    isNew: false,
  },
  {
    id: 'tianmi-jiayuan',
    title: '甜蜜家园',
    author: '金坎比 / 黄英灿',
    rating: 9.4,
    category: 'xuanyi',
    tags: ['悬疑', '恐怖', '生存'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20mysterious%20apartment%20building%20at%20night%2C%20dark%20atmospheric%20horror%20theme%2C%20silhouette%20of%20a%20young%20man%20in%20front%2C%20eerie%20lighting%2C%20minimal%20composition%2C%20thriller%20manga%20cover&width=400&height=560&seq=comic-sweet-home&orientation=portrait',
    description: '因校园暴力而封闭内心的车贤秀，在家人去世后搬到名为"绿之家"的公寓，准备结束自己的生命。然而公寓内外突然爆发可怕的怪物灾难，他与邻居们必须团结起来，在封闭的公寓中为生存而战。',
    chapters: 140,
    updateDate: '2024-07-20',
    rank: 4,
    isHot: false,
    isNew: true,
  },
  {
    id: 'yushen-tongxing',
    title: '与神同行',
    author: '周浩旻',
    rating: 9.5,
    category: 'juqing',
    tags: ['剧情', '奇幻', '感人'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20three%20mysterious%20grim%20reapers%20in%20traditional%20inspired%20outfits%2C%20dramatic%20fantasy%20atmosphere%2C%20ethereal%20glow%2C%20minimal%20background%2C%20premium%20manga%20cover%20art&width=400&height=560&seq=comic-along-with-gods&orientation=portrait',
    description: '消防员金自鸿因公殉职后，被三位阴间使者带领，在49天内经历七大地狱审判。通过七次审判宣告无罪者才能转世，故事展现了人性、亲情与救赎的深刻主题。',
    chapters: 78,
    updateDate: '2024-07-18',
    rank: 5,
    isHot: false,
    isNew: false,
  },
  {
    id: 'yinni-er-weida',
    title: '梨泰院Class',
    author: '光进',
    rating: 9.2,
    category: 'juqing',
    tags: ['剧情', '创业', '复仇'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20determined%20young%20man%20with%20short%20hair%20in%20casual%20clothing%2C%20urban%20night%20background%2C%20warm%20lighting%2C%20clean%20composition%2C%20modern%20manga%20cover&width=400&height=560&seq=comic-itaewon-class&orientation=portrait',
    description: '朴世路因反抗校园霸凌被退学，父亲又因车祸去世。他立志在梨泰院开一家属于自己的餐厅，向害死父亲的餐饮巨头展开漫长的复仇与商业竞争之路。',
    chapters: 81,
    updateDate: '2024-07-15',
    rank: 6,
    isHot: false,
    isNew: false,
  },
  {
    id: 'nailao-xianjing',
    title: '奶酪陷阱',
    author: '纯Kki',
    rating: 9.1,
    category: 'lianai',
    tags: ['恋爱', '校园', '心理'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20university%20couple%20with%20subtle%20tension%2C%20warm%20autumn%20tones%2C%20soft%20lighting%2C%20romantic%20atmosphere%2C%20clean%20minimal%20background%2C%20elegant%20manga%20art&width=400&height=560&seq=comic-cheese-in-trap&orientation=portrait',
    description: '洪雪是一个努力用功的大学生，获得奖学金后重返校园，却遇到了表面完美但内心复杂的学长刘正。她逐渐发现刘正隐藏的另一面，两人之间展开了微妙而危险的关系。',
    chapters: 107,
    updateDate: '2024-07-12',
    rank: 7,
    isHot: false,
    isNew: false,
  },
  {
    id: 'jinmishu-weishenme',
    title: '金秘书为何那样',
    author: '郑景允',
    rating: 9.0,
    category: 'lianai',
    tags: ['恋爱', '职场', '喜剧'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20confident%20businesswoman%20with%20tied%20hair%20in%20office%20attire%2C%20professional%20setting%2C%20warm%20lighting%2C%20clean%20composition%2C%20romantic%20comedy%20vibe%2C%20modern%20manga%20cover&width=400&height=560&seq=comic-whats-wrong-secretary-kim&orientation=portrait',
    description: '跟随副会长李英俊工作九年的完美秘书金微笑突然提出辞职，这让一向自信的李英俊措手不及。为了挽留金秘书，他开始了各种搞笑又浪漫的追求攻势。',
    chapters: 98,
    updateDate: '2024-07-10',
    rank: 8,
    isHot: false,
    isNew: false,
  },
  {
    id: 'tade-sishenghuo',
    title: '她的私生活',
    author: '金成妍',
    rating: 8.9,
    category: 'lianai',
    tags: ['恋爱', '职场', '追星'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20stylish%20woman%20with%20camera%2C%20art%20gallery%20background%2C%20warm%20and%20chic%20atmosphere%2C%20soft%20colors%2C%20clean%20minimal%20composition%2C%20elegant%20manga%20cover%20art&width=400&height=560&seq=comic-her-private-life&orientation=portrait',
    description: '成德美是美术馆的首席策展人，表面上是一位干练的职场女性，私下却是一个狂热的偶像追星族。当新任馆长莱恩·金发现她的秘密后，两人的关系开始发生微妙变化。',
    chapters: 72,
    updateDate: '2024-07-08',
    rank: 9,
    isHot: false,
    isNew: false,
  },
  {
    id: 'yonggan-de-shinu',
    title: '勇敢的市民',
    author: '金正贤',
    rating: 9.0,
    category: 'dongzuo',
    tags: ['动作', '校园', '正义'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20female%20student%20wearing%20boxing%20gloves%20in%20a%20school%20setting%2C%20dynamic%20action%20pose%2C%20determined%20expression%2C%20warm%20colors%2C%20clean%20background%2C%20sports%20manga%20cover%20style&width=400&height=560&seq=comic-brave-citizen&orientation=portrait',
    description: '萧时敏曾是一名拳击手，为了成为教师她隐藏了自己的过去。然而在充满校园暴力的学校里，她不得不摘下伪装，用拳头守护学生的正义与安全。',
    chapters: 65,
    updateDate: '2024-07-05',
    rank: 10,
    isHot: false,
    isNew: true,
  },
  {
    id: 'wode-yeman-nuyou',
    title: '我的野蛮女友',
    author: '金浩植',
    rating: 8.8,
    category: 'gaoxiao',
    tags: ['搞笑', '恋爱', '日常'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20cheerful%20couple%20in%20casual%20clothing%2C%20playful%20romantic%20comedy%20vibe%2C%20bright%20colors%2C%20city%20street%20background%2C%20clean%20composition%2C%20lighthearted%20manga%20cover&width=400&height=560&seq=comic-my-sassy-girl&orientation=portrait',
    description: '牵牛是一个平凡的大学生，偶然在地铁站救下醉酒的女孩后，被迫与她展开了一段啼笑皆非的恋爱关系。这个野蛮女友虽然霸道任性，却有着不为人知的温柔一面。',
    chapters: 55,
    updateDate: '2024-07-02',
    rank: 11,
    isHot: false,
    isNew: false,
  },
  {
    id: 'jinsheng-shi-diyici',
    title: '今生是第一次',
    author: '尹兰中',
    rating: 8.7,
    category: 'lianai',
    tags: ['恋爱', '生活', '治愈'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20couple%20sitting%20together%20in%20a%20cozy%20home%2C%20warm%20interior%20lighting%2C%20soft%20pastel%20colors%2C%20romantic%20slice%20of%20life%20atmosphere%2C%20clean%20composition%2C%20gentle%20manga%20art&width=400&height=560&seq=comic-because-this-is-my-first-life&orientation=portrait',
    description: '尹智好是一名助理编剧，因为各种原因被迫搬出原来的住处。在朋友的介绍下，她与不善社交的IT男南世熙开始了契约婚姻生活，两个陌生人在同一屋檐下逐渐产生真情。',
    chapters: 48,
    updateDate: '2024-06-28',
    rank: 12,
    isHot: false,
    isNew: false,
  },
];

export const faqList = [
  {
    question: '布丁漫画的韩漫资源是免费的吗？',
    answer: '是的，布丁漫画提供的所有韩漫资源均为免费阅读。我们致力于为广大韩漫爱好者提供优质的免费韩漫阅读体验，无需付费即可畅享热门韩漫全集。',
  },
  {
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读是布丁漫画专为移动端和网页端优化的阅读模式。用户只需向下滑动页面即可连续阅读，无需翻页操作，让韩漫阅读更加流畅自然，特别适合长条漫的阅读习惯。',
  },
  {
    question: '布丁漫画的韩漫推荐是如何筛选的？',
    answer: '我们的韩漫推荐基于综合评分系统，考量因素包括：读者评分、阅读量、更新频率、作品质量等多个维度。同时结合编辑团队的精选推荐，确保推荐列表中的每一部韩漫都值得阅读。',
  },
  {
    question: '韩漫更新频率是怎样的？',
    answer: '布丁漫画紧跟各大韩漫平台的更新节奏，热门连载韩漫通常每周更新一话。我们会在第一时间同步最新章节，确保读者不错过任何精彩内容。您可以在每部漫画的详情页查看具体的更新日期。',
  },
  {
    question: '如何找到自己喜欢的韩漫类型？',
    answer: '您可以通过首页的分类导航进入不同的韩漫类型专区，包括恋爱、奇幻、动作、悬疑、搞笑、剧情六大分类。每个分类都有详细的漫画列表和推荐，帮助您快速找到感兴趣的韩漫作品。',
  },
  {
    question: '布丁漫画支持手机阅读吗？',
    answer: '完全支持！布丁漫画采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备，都能获得优质的韩漫阅读体验，随时随地畅享韩漫精彩内容。',
  },
];